module.exports = __webpack_public_path__ + "static/img/bg-en.27f7c25f.webp";